
<div :class="['card-profile-images', { page }]">
  <template v-if="cardFront || cardBack">
    <div class="image-container">
      <card-image
        class="front-image"
        :image-url="cardFront"
        :alt="card.label"
        @click.stop.prevent="fullScreenImage = cardFront"
      />

      <card-image
        v-if="hasBackImage"
        class="back-image"
        :image-url="cardBack"
        :alt="card.label"
        @click.stop.prevent="fullScreenImage = cardBack"
      />
    </div>

    <fullscreen-image
      :show="!!fullScreenImage"
      :image="fullScreenImage"
      :label="card.label"
      :has-back-image="hasBackImage"
      @hide="fullScreenImage = ''"
      @flip="flipFullscreenImage"
    />
  </template>

  <div
    v-else-if="card.collectionCardId"
    class="image-placeholder"
    @click.stop.prevent="edit"
  >
    <icon class="icon" name="cloud_upload" />
    <div>Upload an image</div>
  </div>
</div>
